import { render, staticRenderFns } from "./ReturnGoodsShow.vue?vue&type=template&id=d4383b9a&scoped=true"
import script from "./ReturnGoodsShow.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4383b9a",
  null
  
)

export default component.exports